import axios from 'axios'

export default {
    state : {
        backupCodes: [],
    },
    getters: {
        getBackupCodes(state){
            return state.backupCodes;
        }
    },
    actions: {
        setBackupCode({commit}, payload) {
            commit('setBackupCode', payload)
        },
        addBackupCode(context, payload) {
            return axios.post('/auth-code-backups', payload)
                .then((response)=>{
                    return response;
                })
                .catch((error)=>{
                    return Promise.reject(error);
                })
        },
        updateBackupCode(context, payload) {
            const { id } = payload;
            delete  payload.id;
            return axios.put('/auth-code-backups/' + id, payload)
                .then((response)=>{
                    return response;
                })
                .catch((error)=>{
                    return Promise.reject(error);
                })
        },
        getBackupCode(context, id){
            return axios.get('/auth-code-backups/' + id)
                .then((response)=>{
                    return response;
                })
                .catch((error)=>{
                    return Promise.reject(error);
                })
        },
        getAllBackupCodes(context, queryObject = {}) {
            const query = new URLSearchParams(queryObject).toString();
            return axios.get(`/auth-code-backups${query ? '?' + query : '' }`)
                .then((response)=>{
                    context.commit('setBackupCode', response.data.data);
                    return response;
                })
                .catch((error)=>{
                    return Promise.reject(error);
                })
        },
        deleteBackupCode(context, id) {
            return axios.delete('/auth-code-backups/' + id)
                .then((response)=>{
                    return response;
                })
                .catch((error)=>{
                    return Promise.reject(error);
                })
        },
        deleteBackupCodes(context, ids) {
            return axios.delete('/auth-code-backups/bulk', {
                data: { ids: ids }
            })
                .then((response)=>{
                    return response;
                })
                .catch((error)=>{
                    return Promise.reject(error);
                })
        },
        exportBackupCodes(context, queryObject = {}) {
            const query = new URLSearchParams(queryObject).toString();
            return axios.get(`/auth-code-backups/export${query ? '?' + query : '' }`)
                .then((response)=>{
                    return response;
                })
                .catch((error)=>{
                    return Promise.reject(error);
                })
        },
        generateBackupCodes(context, payload) {
            return axios.post('/auth-code-backups/generate', payload)
                .then((response)=>{
                    return response;
                })
                .catch((error)=>{
                    return Promise.reject(error);
                })
        }
    },
    mutations: {
        setBackupCode(state, payload) {
            state.backupCodes = payload
        }
    }
}